import EchartsTool from './echartsTool.js'

/**
 * 带折线
 * 范围框整个X轴
 * Y轴 - 分
 * 浮窗 - 时分
 */
export default function getEchartsOptionBarC9(xAxis_data, series_data, expansion_data, markArea_range, isDifferentColors, colorArr) {
	
	// pieces
	let pieces = isDifferentColors ? EchartsTool.get_line_visual_map_pieces_3( xAxis_data, colorArr) :  EchartsTool.get_line_visual_map_pieces_4( xAxis_data, colorArr);

	let barWidth = 810 / xAxis_data.length - 5 > 10 ? 10 : undefined

	let isHaveHours = false;
	if (series_data && series_data.length > 0) {
		for (let i = 0; i < series_data.length; i++) {
			let item = series_data[i];
			if (item >= 60) {
				isHaveHours = true;
			}
		} 
	}

	// 区间范围计算
	let xWidth = (810 - 25);
	let singleBarAreaWidth = xWidth / xAxis_data.length;
	let x1;
	let x2;
	if (xAxis_data.indexOf(markArea_range[0]) != -1) {
		x1 = xAxis_data.indexOf(markArea_range[0]) * singleBarAreaWidth + 45.0;
	}
	if (xAxis_data.indexOf(markArea_range[1]) != -1) {
		x2 = (xAxis_data.indexOf(markArea_range[1]) + 1) * singleBarAreaWidth + 45.0;
	}
	let markArea_data;
	if (x1 || x2) {
		markArea_data = markArea_range.length == 2 ? [
			[
				{ yAxis: markArea_range[0], x: x1 },
				{ yAxis: markArea_range[1], x: x2 },
			]
		] : undefined;
	} else {
		markArea_data = markArea_range.length == 2 ? [
			[
				{ yAxis: markArea_range[0] },
				{ yAxis: markArea_range[1] },
			]
		] : undefined;
	}

	let markLine_data = (markArea_range && markArea_range.length == 2) ? [
		{
			yAxis: markArea_range[0]
		},
		{
			yAxis: markArea_range[1]
		}
	] : undefined

	let option = {
		grid: {
			x: 15,
			y: 15,
			x2: 15,
			y2: 10,
			containLabel: true
		},
		tooltip: {
			trigger: "axis",
			backgroundColor: 'rgba(255, 255, 255, 0.95)',
			borderColor: "#C2C4FF",
			borderWidth: 1,
			borderRadius: 4,
			textStyle: {
				color: "#8394B9",
				fontSize: 14
			},
			confine: true,
			formatter: function (val) {
				// 获取日期
				let date = expansion_data[val[0].dataIndex] || '';

				// 获取时分
				let value = val[0].value;
				let num = value
				let hoursMinutes = '';
				if (num == '-') {
					return '-';
				} else {
					let hours = Math.floor(num / 60.0);
					let minutes = num - (hours * 60.0);
					
					if (hours != 0) {
						hoursMinutes = hoursMinutes + hours + '小时';
					}
					if (minutes != 0) {
						hoursMinutes = hoursMinutes + minutes + '分钟';
					}
					if (hours == 0 && minutes == 0) {
						hoursMinutes = '0分钟';
					}
				}

				// 区分颜色
				let dotColor = 'rgba(74, 124, 232, 1)';
				let textColor = 'rgba(131, 148, 185, 1)';
				if (EchartsTool.get_deal_color_arr_1(xAxis_data, colorArr)[val[0].dataIndex] == 1) {
					dotColor = 'rgba(255, 113, 134, 1)';
					textColor = 'rgba(255, 113, 134, 1)';
				}

				// 弹窗样式
				let titleDiv = `<div style='font-family: PingFangSC, PingFang SC; font-weight: 400; font-size: 14px; color: ${textColor}; line-height: 17px;'>${date}</div>`
				let contentDiv = `
				<div style="display: flex; align-items: center; margin-top: 5px;">
					<span style='display:inline-block;margin-right:5px;margin-left:0px;border-radius:10px;width:6px;height:6px;background-color:${dotColor}'></span>
					<div style='font-family: PingFangSC, PingFang SC; font-weight: 400; font-size: 14px; color: ${textColor}; line-height: 17px;'>${hoursMinutes}</div>
				</div>
				`
				return titleDiv + contentDiv;
			}
		},
		dataZoom: {
			type: 'inside',
			zoomLock: true
		},
		xAxis: {
			type: 'category',
			data: xAxis_data,
			axisTick: { // 坐标轴刻度相关设置。
				show: false
			},
			axisLine: { // 坐标轴轴线相关设置。
				lineStyle: {
					color: "#A5A9BC",
				},
			},
			axisLabel: { // 坐标轴刻度标签的相关设置。
				show: true,
				textStyle: {
					color: "#A5A9BC", //坐标的字体颜色
					fontSize: 10
				},
				formatter: function (val, index) {
					return val;
				},
				// interval: 5 // 强制设置坐标轴分割间隔。
			},
		},
		yAxis: [
			{ // y 轴配置项
				axisTick: { // 坐标轴刻度相关设置。
					show: false
				},
				axisLine: { // 坐标轴轴线相关设置。
					show: false
				},
				axisLabel: { // 坐标轴刻度标签的相关设置。
					formatter: function (val) {
						if (isHaveHours) {
							if (val % 60 == 0) {
								return (val / 60) + 'h'
							}
						} else {
							return val + '分';
						}
					},
					textStyle: {
						color: "#A5A9BC", //坐标的字体颜色
						fontSize: 10
					}
				},
				minInterval: isHaveHours ? 60 : undefined
			},
			{ // y 轴配置项
				axisTick: { // 坐标轴刻度相关设置。
					show: false
				},
				axisLine: { // 坐标轴轴线相关设置。
					show: false
				},
				axisLabel: { // 坐标轴刻度标签的相关设置。
					formatter: function (val) {
						if (isHaveHours) {
							if (val % 60 == 0) {
								return (val / 60) + 'h'
							}
						} else {
							return val + '分';
						}
					},
					textStyle: {
						color: "#A5A9BC", //坐标的字体颜色
						fontSize: 10
					}
				},
				minInterval: isHaveHours ? 60 : undefined
			}
		],
		visualMap: {
			show: false,
			dimension: 0,
			seriesIndex: 1,
			pieces: pieces
		},
		series: [
			{
				type: 'bar',
				data: series_data,
				itemStyle: {
					normal: {
						barBorderRadius: [4, 4, 0, 0],
						color: function(params) {
							if (isDifferentColors) {
								if (colorArr && colorArr.length > 0) {
									if (colorArr[params.dataIndex] == 0) { // 正常
										if (params.dataIndex == series_data.length - 1) {
											return 'rgba(74, 124, 232, 1)'
										}
										return 'rgba(74, 124, 232, 0.1)'
									} else { // 异常
										if (params.dataIndex == series_data.length - 1) {
											return 'rgba(255, 113, 134, 1)'
										}
										return 'rgba(255, 113, 134, 0.1)'
									}
								} else {
									return 'rgba(74, 124, 232, 0.1)'
								}
							} else {
								return 'rgba(74, 124, 232, 0.1)'
							}
						}
					},
				},
				markArea: {
					itemStyle: {
						color: 'rgba(74, 124, 232, 0.05)',
						lineStyle: {
							type: "dashed",
							color: "#8287F4",
						},
						// borderColor: "#9EB8F1",
						// borderWidth: 1.8,
						// borderType: 'dotted',
					},
					data: markArea_data,
				},
				markLine: {
						zIndex: -1,
						symbol: ['none', 'none'],
						label: {
						show: false
						},
						lineStyle: {
							color: '#9EB8F1'
						},
						emphasis: {
							disabled: true // 关闭高亮
						},
						data: markLine_data
				},
				barWidth: 22
			},
			{
				data: series_data,
				type: 'line',
				symbol: 'circle',
				symbolSize: 6,
				color: 'rgba(154, 181, 241, 1)',
				itemStyle: {
					normal: {
						borderWidth: 1.5,
						borderColor: '#FFFFFF'
					},
				},
				emphasis: {
					scale: 1.5
				}
			}
		]
	}
	return option;
}